// extracted by mini-css-extract-plugin
export default {"gallery":"galleryIcon_gallery__Dgma9","photoIcon":"galleryIcon_photoIcon__wjhtH"};